module.exports = __webpack_public_path__ + "static/media/bdb-advisory-ico-blue.5e06fe3d.svg";